import { gql } from '@apollo/client'

import { ModalLock } from '../modal-lock'
import {
  PayPerViewLock_OfferLockDataFragment,
  PayPerViewLock_ViewerFragment,
} from './__generated__/pay-per-view-lock.graphql'
import { FirstBuyOrFiveMonitorCreditsContent } from './first-buy-or-five-monitor-credits-content'
import { OneMonitorCreditsBuyContent } from './one-monitor-credits-buy-content'

type PayPerViewLockProps = {
  offerLockData: PayPerViewLock_OfferLockDataFragment
  viewer: PayPerViewLock_ViewerFragment
}

export function PayPerViewLock({ offerLockData, viewer }: PayPerViewLockProps) {
  const hasBenefits = !!offerLockData.body.cards[0]?.benefitsList?.length

  return (
    <ModalLock size="sm" offerLockBody={offerLockData.body}>
      {hasBenefits ? (
        <FirstBuyOrFiveMonitorCreditsContent offerLockData={offerLockData} viewer={viewer} />
      ) : (
        <OneMonitorCreditsBuyContent offerLockData={offerLockData} viewer={viewer} />
      )}
    </ModalLock>
  )
}

PayPerViewLock.fragments = {
  offerLockData: gql`
    fragment PayPerViewLock_offerLockData on OfferLockData {
      ...FirstBuyOrFiveMonitorCreditsContent_offerLockData
      ...OneMonitorCreditsBuyContent_offerLockData
      body {
        ...ModalLock_offerLockBody
      }
    }
    ${ModalLock.fragments.offerLockBody}
    ${FirstBuyOrFiveMonitorCreditsContent.fragments.offerLockData}
    ${OneMonitorCreditsBuyContent.fragments.offerLockData}
  `,
  viewer: gql`
    fragment PayPerViewLock_viewer on Profile {
      ...FirstBuyOrFiveMonitorCreditsContent_viewer
      ...OneMonitorCreditsBuyContent_viewer
    }
    ${FirstBuyOrFiveMonitorCreditsContent.fragments.viewer}
    ${OneMonitorCreditsBuyContent.fragments.viewer}
  `,
}
